/**
 * MDR as the alert panel's host (task 191b): the panel reads MDR's own
 * sign-in token and links through MDR's router. The Tickets app provides
 * its own host, with its token and cross-app links into MDR.
 */

import { Link } from '@tanstack/react-router';

import type { MdrPanelHost } from '@bluesphere/mdr-alert-panel';

import { useAccessToken } from '../auth/useAccessToken';

export const mdrPanelHost: MdrPanelHost = {
  useToken: useAccessToken,
  renderLink: (target, { className, children }) =>
    target.to === 'alert' ? (
      <Link to="/alerts/$alertRef" params={{ alertRef: target.alertRef }} className={className}>
        {children}
      </Link>
    ) : (
      <Link
        to="/detections/$detectionId"
        params={{ detectionId: target.detectionId }}
        className={className}
      >
        {children}
      </Link>
    ),
};
